import React, { useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartColumnStacked from '../../../../components/charts/ChartColumnStacked'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartLineThemes } from '../../../../components/charts/types/ChartLine'
import { STATUS_DELIVERED, STATUS_CANCELLED } from '../../../../types/Order'

const GET_DATA = gql`
  query OrdersDevice {
    ordersAggs(
      size: 0,
      query: {
        bool: {
          filter: [
            {
              terms: {
                status_translate_keyword: [
                  "${STATUS_DELIVERED}",
                  "${STATUS_CANCELLED}"
                ]
              }
            }
          ]
        }
      },
      aggs: {
        devices: {
          terms: {
            field: "client_id",
            size: 10
          },
          aggs: {
            delivered: {
              filter: {
                term: {
                  status_translate_keyword: "${STATUS_DELIVERED}"
                }
              }
            },
            cancelled: {
              filter: {
                term: {
                  status_translate_keyword: "${STATUS_CANCELLED}"
                }
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

const OrdersDevice = (): JSX.Element => {
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData()
  }, [])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.ordersAggs.aggregations.devices
  const categories: Array<string> = []
  buckets.map((bucket: any) => {
    categories.push(bucket.key)
  })
  const arrayCancelled: any = buckets.map((bucket: any) => {
    return bucket.cancelled.doc_count
  })
  const arrayDelivered: any = buckets.map((bucket: any) => {
    return bucket.delivered.doc_count
  })
  const options = {
    chart: {
      id: 'finished-orders-history'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    }
  }
  const series = [{
    name: 'cancelados',
    data: arrayCancelled
  }, {
    name: 'entregues',
    data: arrayDelivered
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Pedidos entregues e cancelados por device</Typography>
    <ChartColumnStacked options={options} series={series} theme={ChartLineThemes.twocolors} height={280} />
  </Paper>
}

export default OrdersDevice
